<template>
  <PageWrapper
      :isLoading="isLoading"
      hasFilters
      @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title>
      لیست کاربران {{ isVipUsersList ? "VIP" : "" }}
      <!-- تعداد کل نتایج (با فیلترهای فعلی)، فقط در لیست کاربران عادی -->
      <b-badge v-if="!isVipUsersList && totalCount !== null" variant="light-primary" class="users-count">
        {{ Intl.NumberFormat("en-US").format(totalCount) }} کاربر
      </b-badge>
    </template>
    <template #titleBtn>
      <b-link to="/users/create" class="btn btn-success" v-if="!isVipUsersList">
        افزودن کاربر جدید
      </b-link>
      <BButton variant="success" v-else @click="renderAddVipToUserModal">
        افزودن پلن VIP به کاربر
      </BButton>
    </template>
    <template #filters>
      <SearchInput
          class="filters-width w-24"
          inputId="fullName"
          inputLabel="جستجو بر اساس نام کاربر"
          inputPlaceholder="علی..."
          v-model="usersListFilter.fullName"
          @enter="setPageNumberAndSendRequest"
      />
      <SearchInput
          class="filters-width w-24"
          inputId="mobile"
          inputLabel="جستجو بر اساس شماره کاربر"
          inputPlaceholder="0912..."
          v-model="usersListFilter.mobile"
          @enter="setPageNumberAndSendRequest"
      />
      <SearchInput
          class="filters-width w-24"
          inputId="email"
          inputLabel="جستجو بر اساس ایمیل کاربر"
          inputPlaceholder="info@ferman.org"
          v-model="usersListFilter.email"
          @enter="setPageNumberAndSendRequest"
      />
      <CustomSelect
          v-if="!isVipUsersList"
          class="filters-width w-24"
          inputId="userRole"
          inputLabel="نقش کاربر"
          :customOptions="roleOptions"
          v-model="usersListFilter.type"
      />
      <LanguagePicker
          v-if="!isVipUsersList"
          class="filters-width w-24"
          placeHolder="نمایش کاربرانی که برای این زبان رودمپ ندارند"
          @getLanguage="setRoadmapLanguageId"
      />
      <CustomDatePicker
          v-if="!isVipUsersList"
          class="filters-width w-24"
          inputId="createDate"
          @getSelectedDate="setCreateDate"
          inputLabel="تاریخ ایجاد"
          inputPlaceholder="1403/06/05"
      />
      <template v-if="isVipUsersList">
        <CustomSelect
            class="w-24 filters-width"
            inputId="isActiveVip"
            inputLabel="وضعیت اشتراک VIP"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.isActiveVip"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasMidnightReserve"
            inputLabel="وضعیت رزرو نیمه شب پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasMidnightReserve"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasMasterReserve"
            inputLabel="وضعیت رزرو استاد پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasMasterReserve"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasFridayReserve"
            inputLabel="وضعیت رزرو جمعه پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasFridayReserve"
        />
        <CustomDatePicker
            class="filters-width w-24"
            inputId="vipExpireTimeBigger"
            @getSelectedDate="setVipExpireTime"
            inputLabel="پلن های فعال تا تاریخ"
            inputPlaceholder="1403/06/05"
        />
      </template>
    </template>
    <CustomTable
        v-if="usersList"
        :class="{ 'users-compact': !isVipUsersList }"
        :pageNumber="usersListFilter.pageNumber"
        :count="usersListFilter.count"
        :totalCount="totalCount"
        :tableColumns="tableColumns"
        :tableItems="usersList"
        @changePage="changePage"
    >
      <template #type="data">
        <span :class="{ 'text-nowrap': !isVipUsersList }">{{ usersTypeEnum[data.item.type] }}</span>
      </template>
      <template #fullName="data">
        <template v-if="isVipUsersList">{{ data.item.fullName }}</template>
        <span v-else class="users-name">
          <span
              class="status-dot"
              :class="`status-dot--${userStatus(data.item).color}`"
              :title="userStatus(data.item).text"
              v-b-tooltip.hover
          ></span>
          <span class="sr-only">{{ userStatus(data.item).text }}،</span>
          <button
              v-if="data.item.fullName"
              type="button"
              class="users-copy users-copy--name"
              :title="`کپی ${data.item.fullName}`"
              @click="copyText(data.item.fullName, 'نام')"
          >{{ data.item.fullName }}</button>
          <template v-else>-</template>
        </span>
        <div v-if="!isVipUsersList" class="users-mobile-contact">
          <button
              v-if="data.item.email"
              type="button"
              class="users-copy users-email"
              @click="copyText(data.item.email, 'ایمیل')"
          >{{ data.item.email }}</button>
          <button
              v-if="data.item.mobile"
              type="button"
              class="users-copy mobile-ltr"
              @click="copyText(formatMobileForDisplay(data.item.mobile), 'شماره')"
          >{{ formatMobileForDisplay(data.item.mobile) }}</button>
        </div>
      </template>
      <template #email="data">
        <template v-if="isVipUsersList">{{ data.item.email || "-" }}</template>
        <template v-else>
        <button
            v-if="data.item.email"
            type="button"
            class="users-copy users-email"
            :title="`کپی ${data.item.email}`"
            @click="copyText(data.item.email, 'ایمیل')"
        >{{ data.item.email }}</button>
        <button
            v-if="data.item.mobile"
            type="button"
            class="users-copy mobile-ltr"
            :title="`کپی ${formatMobileForDisplay(data.item.mobile)}`"
            @click="copyText(formatMobileForDisplay(data.item.mobile), 'شماره')"
        >{{ formatMobileForDisplay(data.item.mobile) }}</button>
        <span v-if="!data.item.email && !data.item.mobile" class="text-muted">-</span>
        </template>
      </template>
      <template #mobile="data">
        <span class="mobile-ltr" dir="ltr" :title="data.item.mobile || '-'">
          {{ formatMobileForDisplay(data.item.mobile) }}
        </span>
      </template>
      <template #status="data">
        {{ data.item.status ? "فعال" : "غیر فعال" }}
      </template>
      <template #loyaltyLevel="data">
        <span v-if="loyaltyLevels[data.item.userId] === undefined" class="text-muted">…</span>
        <b-badge v-else-if="loyaltyLevels[data.item.userId]" variant="light-warning">
          {{ loyaltyLevels[data.item.userId] }}
        </b-badge>
        <span v-else class="text-muted">-</span>
      </template>
      <template #vipExpiredDate="data">
        <span style="white-space: nowrap !important">
          {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }} -
          {{ new Date(data.item.createDate).toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" }) }}
        </span>
      </template>
      <template #vipUser.title="data">
        <b-link :to="`/apps/vip/plans/${data.item.vipUserId}`" v-if="data.item.vipUser && data.item.vipUser.title">
          {{ data.item.vipUser.title }}
        </b-link>
      </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #actions="data">
        <div class="d-flex align-items-center justify-content-between">
          <template v-if="!isVipUsersList">
            <b-link :to="`/users/${data.item.userId}`">
              <FeatherIcon class="text-primary" icon="EditIcon" size="20" />
            </b-link>
          </template>
          <template v-else>
            <BButton size="sm" variant="transparent" @click="getVipPlanDeleteConfirmation(data.item)">
              <FeatherIcon class="text-danger" icon="Trash2Icon" size="20" />
            </BButton>
          </template>
        </div>
      </template>
    </CustomTable>
    <DeleteUserVipPlanConfirmationDialog @refetch="getAllUsers" :tempUserObject="tempUserObject" />
    <AddVipToUserModal @updateVipUsersList="getAllUsers" />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import { GetAllUsersList } from "@/libs/Api/Users";
import { GetAllUserTypes } from "@/libs/Api/UserType";
import { GetListLevelLoyaltUser } from "@/libs/Api/LevelLoyalty";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AddVipToUserModal from "@/views/components/VipUser/AddVipToUserModal.vue";
import DeleteUserVipPlanConfirmationDialog from "@/views/components/VipUser/DeleteUserVipPlanConfirmationDialog.vue";
import { BButton, BLink, BBadge, VBTooltip } from "bootstrap-vue";

export default {
  props: { isVipUsersList: { type: Boolean, default: false } },
  data() {
    return {
      isLoading: false,
      usersTypeEnum: {1:"مدیر کل",2:"مدیر زبان",3:"مدرس",4:"زبان آموز",5:"حسابدار",6:"پشتیبان",7:"بلاگر",8:"طراح سوال"},
      usersListFilter: { pageNumber:null,count:10,type:null,languageId:null,isVipAtLeastOne:null,isActiveVip:null,vipExpireTimeBigger:null,roadMapLangId:null,email:null,mobile:null,createDate:null,fullName:null,hasMidnightReserve:null,hasMasterReserve:null,hasFridayReserve:null },
      // نقش‌ها از UserType/GetAll پر می‌شوند؛ «همه» یعنی فیلتر type فرستاده نمی‌شود
      roleOptions:[{value:null,text:"همه"}],
      filterActiveStatuses:[{value:null,text:"همه"},{value:true,text:"فعال ها"},{value:false,text:"غیر‌فعال ها"}],
      usersList:null,
      // userId → نام سطح وفاداری (undefined یعنی در حال دریافت، null یعنی سطحی ندارد)
      loyaltyLevels:{},
      totalCount:null,
      tempUserObject:null,
    };
  },
  watch: {
    isVipUsersList: { handler() { this.setVipListFiltersOnChangeOfIsVipVariable(); this.getAllUsers(); } }
  },
  created() { this.setVipListFiltersOnChangeOfIsVipVariable(); },
  mounted() { this.getAllUsers(); this.getUserTypes(); },
  methods: {
    setCreateDate(d) { this.usersListFilter.createDate = d ? new Date(d).toISOString() : null; },
    setVipExpireTime(d) { this.usersListFilter.vipExpireTimeBigger = d ? new Date(d).toISOString() : null; },
    renderAddVipToUserModal() { this.$bvModal.show("add-vip-to-user"); },
    setVipListFiltersOnChangeOfIsVipVariable() {
      if(this.isVipUsersList){
        this.usersListFilter.isVipAtLeastOne=true;
      } else {
        this.usersListFilter.isVipAtLeastOne=null;
      }
      this.usersListFilter.pageNumber = this.computedPageRouteQuery||1;
    },
    getVipPlanDeleteConfirmation(u){ this.tempUserObject=JSON.parse(JSON.stringify(u)); this.$bvModal.show("vip-delete-confirmation-dialog"); },
    setPageNumberAndSendRequest(){ this.usersListFilter.pageNumber=1; this.setPageNumberQuery(1); this.getAllUsers(); },
    changePage(val){ this.usersListFilter.pageNumber=val; this.setPageNumberQuery(val); this.getAllUsers(); },
    setPageNumberQuery(pageNumber){ this.$router.replace({ path:this.$route.path, query:{ page:pageNumber } }); },
    setRoadmapLanguageId(langId){ this.usersListFilter.roadMapLangId=langId; },
    // Users/GetAll سطح وفاداری را برنمی‌گرداند؛ برای هر کاربر صفحه با شماره‌اش از لیست سطح‌ها جستجو می‌شود
    async loadLoyaltyLevels(users) {
      const requestId = (this.loyaltyRequestId = (this.loyaltyRequestId || 0) + 1);
      this.loyaltyLevels = {};
      await Promise.all((users || []).map(async (user) => {
        let level = null;
        if (user.mobile) {
          try {
            const req = new GetListLevelLoyaltUser(this);
            req.setRequestParam({ pageNumber:1, count:5, search:user.mobile });
            const res = await new Promise((resolve, reject) => req.send(resolve, reject));
            const rows = (res && res.data && res.data.data) || [];
            const row = rows.find(r => r.user && r.user.userId === user.userId);
            level = (row && row.levelLoyalt && row.levelLoyalt.name) || null;
          } catch (e) { console.error(e); }
        }
        if (requestId === this.loyaltyRequestId) this.$set(this.loyaltyLevels, user.userId, level);
      }));
    },
    // سبز: فعال · زرد: فعال ولی اجازه‌ی ورود به سایت ندارد (isShow) · قرمز: غیرفعال
    userStatus(user) {
      if (!user.status) return { color: "red", text: "غیر فعال" };
      if (user.isShow === false) return { color: "yellow", text: "فعال، بدون دسترسی به سایت" };
      return { color: "green", text: "فعال" };
    },
    async copyText(text, label) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast({
          component: ToastificationContent,
          props: { title: `${label} کپی شد`, icon: "CopyIcon", variant: "success" },
        });
      } catch (e) { console.error(e); }
    },
    async getUserTypes() {
      try{
        const req = new GetAllUserTypes(this);
        await req.fetch(res => {
          const list = Array.isArray(res) ? res : (res && res.data) || [];
          const types = list.filter(t => t && t.userTypeId);
          this.roleOptions = [{value:null,text:"همه"}, ...types.map(t => ({ value:t.userTypeId, text:(t.title || t.name || "").trim() }))];
          // نقش‌هایی که در فهرست ثابت نبودند (مثل منتور) هم در جدول اسم داشته باشند
          types.forEach(t => { if(!this.usersTypeEnum[t.userTypeId]) this.$set(this.usersTypeEnum, t.userTypeId, (t.title || t.name || "").trim()); });
        }, e=>console.error(e));
      }catch(e){ console.error(e); }
    },
    async getAllUsers() {
      try{
        this.isLoading=true;
        const req = new GetAllUsersList(this);
        req.setRequestParamDataObj(this.usersListFilter);
        await req.fetch(res => { if(res.isSuccess){ this.usersList=res.data.users; this.totalCount=res.data.usersCount; if(!this.isVipUsersList) this.loadLoyaltyLevels(res.data.users); } }, e=>console.error(e));
      }finally{ this.isLoading=false; }
    },
    convertNumbers2English(str=""){ return String(str).replace(/[\u0660-\u0669\u06f0-\u06f9]/g,c=>String.fromCharCode(c.charCodeAt(0)&0xf)); },
    mobileDir(value){ if(!value)return "auto"; return /[0-9\u06F0-\u06F9\u0660-\u0669]/.test(String(value))?"ltr":"auto"; },
    formatMobileForDisplay(value){ if(!value)return "-"; return this.convertNumbers2English(String(value)); }
  },
  computed:{
    tableColumns(){
      if(this.isVipUsersList){
        return [
          { key:"userId", label:"شناسه کاربر" },
          { key:"fullName", label:"نام کاربر" },
          { key:"mobile", label:"شماره همراه" },
          { key:"email", label:"ایمیل" },
          { key:"type", label:"نقش کاربر" },
          { key:"status", label:"وضعیت کاربر" },
          { key:"vipExpiredDate", label:"تاریخ اتمام اشتراک VIP" },
          { key:"vipUser.title", label:"نام پلن" },
          { key:"actions", label:"عملیات" },
        ];
      }
      return [
        { key:"userId", label:"شناسه" },
        { key:"fullName", label:"کاربر" },
        { key:"email", label:"اطلاعات تماس" },
        { key:"type", label:"نقش" },
        { key:"loyaltyLevel", label:"سطح وفاداری" },
        { key:"actions", label:"عملیات" },
      ];
    },
    pageNumber(){ return this.usersListFilter.pageNumber; },
    computedPageRouteQuery(){ return this.$route.query?.page||null; }
  },
  directives:{ "b-tooltip": VBTooltip },
  components:{ PageWrapper, CustomTable, SearchInput, CustomDatePicker, CustomSelect, BButton, BLink, BBadge, LanguagePicker, AddVipToUserModal, DeleteUserVipPlanConfirmationDialog }
};
</script>

<style scoped>
.mobile-ltr{direction:ltr;unicode-bidi:embed;display:inline-block;white-space:nowrap;}
.users-count{margin-left:8px;font-size:0.85rem;vertical-align:middle;}
/* لیست کاربران عادی: عنوان ستون‌ها همیشه یک‌خطی */
.users-compact ::v-deep th{white-space:nowrap;}
.users-name{display:inline-flex;align-items:center;gap:6px;font-weight:600;white-space:nowrap;}
.status-dot{width:8px;height:8px;flex-shrink:0;border-radius:50%;}
.status-dot--green{background:#28c76f;box-shadow:0 0 0 3px rgba(40,199,111,0.18);}
.status-dot--yellow{background:#ff9f43;box-shadow:0 0 0 3px rgba(255,159,67,0.18);}
.status-dot--red{background:#ea5455;box-shadow:0 0 0 3px rgba(234,84,85,0.18);}
/* ایمیل‌های بلند جدول را پهن نکنند؛ متن کامل در title */
.users-email{max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;direction:ltr;}
.users-copy{display:block;padding:0;border:0;background:none;color:inherit;font-size:0.8rem;line-height:1.6;text-align:left;cursor:copy;}
.users-copy:hover{color:#7367f0;}
.users-copy--name{font-size:inherit;font-weight:600;line-height:inherit;}
/* موبایل: ستون «اطلاعات تماس» پنهان و همان اطلاعات زیر نام؛ تا ایمیل بدون اسکرول افقی دیده شود */
.users-mobile-contact{display:none;}
@media (max-width:767.98px){
  .users-mobile-contact{display:block;margin-top:2px;}
  .users-compact ::v-deep th:nth-child(3),
  .users-compact ::v-deep td:nth-child(3){display:none;}
}
</style>